<template>
  <div class="top-ui">
    <div class="top-ui-header">
      <h1 class="logo"></h1>
      <ul class="top-ui-util">
        <li class="talk">
          <p class="dot"></p>
          {{this.$t('mirroring.consulting')}}
        </li>
        <li class="timmer" v-if="timer">{{timer}}</li>
      </ul>
    </div>
    <div class="top-ui-btn-area">
      <ul class="top-ui-btn">
        <li class="draw-btn-li">
          <button class="draw-btn pointer"
                  :class="{ 'enabled': $parent.toolkit === 'LaserPointer' }"
                  @click="onClickPalette($event, { toolkit: 'LaserPointer'})"
          ></button>
        </li>
        <li class="draw-btn-li">
          <button class="draw-btn pen"
                  :class="{ 'enabled': $parent.toolkit === 'Pencil' }"
                  @click="onClickPalette($event, { toolkit: 'Pencil' })"
          ></button>
        </li>
        <li class="draw-btn-li">
          <button class="draw-btn highlighter"
                  :class="{ 'enabled': $parent.toolkit === 'Highlighter' }"
                  @click="onClickPalette($event, { toolkit: 'Highlighter' })"
          ></button>
        </li>
        <li class="draw-btn-li">
          <button class="draw-btn eraser"
                  :class="{ 'enabled': $parent.toolkit === 'Eraser' }"
                  @click="onClickPalette($event, { toolkit: 'Eraser' })"
          ></button>
        </li>
      </ul>
      <div class="">
        <button class="exit-btn">{{this.$t('mirroring.stop')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoomMirroringPalette',
  data() {
    return {
      selectedColor: '',
    }
  },
  methods: {
    onClickPalette(e, data) {
      this.$emit('click', { e, data });
    },
  },
  computed: {
    timer() {
      return this.$parent.currentRemainTime
    }
  }
}
</script>

<style lang="scss" scoped>

.top-ui {
  width: 100%;
  background-color: #016bff;
}

.top-ui-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  padding: 0 8px;

  .logo {
    width: 50px;
    height: 24px;
    background: url('~@/assets/images/logo_grm_tx_white.svg') no-repeat left center / auto 100%;
  }

  .top-ui-util {
    display: flex;
    align-items: center;
  }

  .talk {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    color: white;

    .dot {
      margin-right: 4px;
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background-color: white;
    }
  }

  .timmer {
    margin-left: 10px;
    padding: 5px 10px;
    border-radius: 50px;
    background-color: rgba(255,255,255,0.2);
    // background-color: rgba(1,107,255,0.1);
    font-size: 12px;
    color: white;
  }
}

.top-ui-btn-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f4f4f4;
  padding: 8px;
}

.top-ui-btn {
  display: flex;

  .draw-btn-li {
    width: 44px;
    height: 40px;
    border: 1px solid rgba(0,0,0,0.2);
    border-left: none;

    &:first-child {
      border-radius: 6px 0 0 6px;
      border: 1px solid rgba(0,0,0,0.2);
    }

    &:last-child {
      border-radius: 0 6px 6px 0;
    }
  }

  .draw-btn {
    width: 100%;
    height: 100%;
  }

  .pointer {
    border-radius: 5px 0 0 5px;
    background: white url('~@/assets/images/palette/pointer_gray.svg') no-repeat center / 44% auto;

    &.enabled {
      background: #016bff url('~@/assets/images/palette/pointer_white.svg') no-repeat center / 44% auto;
    }
  }

  .pen {
    background: white url('~@/assets/images/palette/pen_gray.svg') no-repeat center / 44% auto;

    &.enabled {
      background: #016bff url('~@/assets/images/palette/pen_white.svg') no-repeat center / 44% auto;
    }
  }

  .highlighter {
    background: white url('~@/assets/images/palette/highlighter_gray.svg') no-repeat center / 44% auto;

    &.enabled {
      background: #016bff url('~@/assets/images/palette/highlighter_white.svg') no-repeat center / 44% auto;
    }
  }

  .eraser {
    border-radius: 0 5px 5px 0;
    background: white url('~@/assets/images/palette/eraser_gray.svg') no-repeat center / 44% auto;

    &.enabled {
      background: #016bff url('~@/assets/images/palette/eraser_white.svg') no-repeat center / 44% auto;
    }
  }
}

.exit-btn {
  box-sizing: border-box;
  padding: 8px 14px;
  border-radius: 6px;
  background-color: white;
  border: 1px solid red;
  font-size: 14px;
}
</style>